module.exports = __webpack_public_path__ + "static/media/precautions.4f8369a7.jpg";